import { createApiSaga } from '../../../sagaGenerator';
import { apiGet } from '../../../../middleware/api';
import {
  GET_TSUNAMI_EVENT_INFO_REQUEST,
  GET_TSUNAMI_EVENT_INFO_SUCCESS,
  GET_TSUNAMI_EVENT_INFO_FAILURE,
  GET_TSUNAMI_EVENT_INFO_REFERENCES_REQUEST,
  GET_TSUNAMI_EVENT_INFO_REFERENCES_SUCCESS,
  GET_TSUNAMI_EVENT_INFO_REFERENCES_FAILURE,
} from './tsunamiEventInfoReducer';

const getTsunamiEventInfoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/info`, ...action }),
  requestType: GET_TSUNAMI_EVENT_INFO_REQUEST,
  successType: GET_TSUNAMI_EVENT_INFO_SUCCESS,
  failureType: GET_TSUNAMI_EVENT_INFO_FAILURE,
});

const getTsunamiEventReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/references`, ...action }),
  requestType: GET_TSUNAMI_EVENT_INFO_REFERENCES_REQUEST,
  successType: GET_TSUNAMI_EVENT_INFO_REFERENCES_SUCCESS,
  failureType: GET_TSUNAMI_EVENT_INFO_REFERENCES_FAILURE,
});

export const tsunamiEventInfoSagas = [
  getTsunamiEventInfoSaga,
  getTsunamiEventReferencesSaga,
];
